import { fg } from '@atlassian/jira-feature-gating';

export const getWillShowNav4UserOptOutForDogfooding = () =>
	fg('jira_nav4_dogfooding') &&
	(fg('jira_nav4_dogfooding_phase-1') || fg('jira_nav4_dogfooding_phase-2'));
